const TUIContact = {
  "群聊通知": "Group Chat Notifications",
  "系统通知": "System Notifications",
  "我的群聊": "My Group Chats",
  "输入群ID，按回车搜索": "Enter a group ID",
  "群名称": "Group name",
  "群ID": "Group ID",
  "加入群聊": "Join group chat",
  "解散群聊": "Disband group chat",
  "退出群聊": "Quit group chat",
  "进入群聊": "Enter group chat",
  "群类型": "Group type",
  "请填写验证信息": "Enter the verification info",
  "申请加入": "Request to join",
  "已申请":"Requested",
  "接受": "Accept",
  "拒绝": "Refuse",
  "已处理": "Handled",
  "添加群聊": "add group chat",
  "已加入": "joined",
  "该群组不存在": "The group does not exist",
  "加群": "join",
  "我的好友": "Friend",
  "发送消息": "Send Message",
  "个性签名": "Signature"
}

export default TUIContact;
